import { Modal } from 'antd'
import {
  ActionMenu,
  ButtonText,
  ItemDeleteText,
  ItemText,
  Main,
  StyledDropDownButton,
} from 'components/ActionStyles/ActionStyles'
import DownArrow from 'components/icons/DownArrow'
import React from 'react'
import { ViewButton } from '../../../../../components/ActionStyles/ActionStyles'

const { confirm } = Modal

const ActionDropdown = ({
  rowData,
  setViewUserDrawer,
  getSingleUserInfo,
  setAddUserDrawer,
  setUserId,
  updateUserStatus,
  deleteUser,
  getUserData,
  inActiveTemplate,
  sendNotificationEmail,
  activeTemplate,
  permittedCruds,
}) => {
  const onClickView = rowId => {
    setViewUserDrawer(true)
    getSingleUserInfo(rowId)
  }

  const onClickEdit = rowData => {
    setAddUserDrawer(true)
    setUserId(rowData?._id)
    getSingleUserInfo(rowData?._id)
  }

  const onDelete = async () => {
    confirm({
      title: 'Delete User?',
      okText: 'Confirm',
      okType: 'primary',
      cancelText: 'Cancel',
      onOk: async () => {
        let response = await deleteUser({ userId: rowData?._id })
        if (response?.status >= 200 && response?.status <= 300) getUserData()
      },
    })
  }

  const onUpdateStatus = async status => {
    let response = await updateUserStatus({
      userId: rowData?._id,
      status: status,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      if (!status && inActiveTemplate) {
        let name = rowData?.first_name + ' ' + rowData?.last_name
        let template
        template = inActiveTemplate?.templateText.replace('{UserName}', name)
        let mailObj = {
          to: rowData?.email,
          subject: 'Your Account  is Inactive - Pluginlive',
          htmlBody: template,
        }
        sendNotificationEmail(mailObj)
      }
      if (status && activeTemplate) {
        let name = rowData?.first_name + ' ' + rowData?.last_name
        let template
        template = activeTemplate?.templateText.replace('{UserName}', name)
        let mailObj = {
          to: rowData?.email,
          subject: 'Your Account  is Activated - Pluginlive',
          htmlBody: template,
        }
        sendNotificationEmail(mailObj)
      }
      getUserData()
    }
  }
  let menuItems = [
    {
      key: 'edit',
      hidden: !permittedCruds?.includes('EDIT'),

      label: <ItemText onClick={() => onClickEdit(rowData)}>Edit</ItemText>,
    },
    rowData?.is_active
      ? {
          key: 'inactive',
          hidden: !permittedCruds?.includes('ACTIVE/INACTIVE'),

          label: (
            <ItemText onClick={() => onUpdateStatus(false)}>
              Set to Inactive
            </ItemText>
          ),
        }
      : {
          key: 'active',
          hidden: !permittedCruds?.includes('ACTIVE/INACTIVE'),
          label: (
            <ItemText onClick={() => onUpdateStatus(true)}>
              Set to Active
            </ItemText>
          ),
        },
    // {
    //   type: 'divider',
    //   hidden: !permittedCruds?.includes('DELETE'),
    // },
    // {
    //   key: 'delete',
    //   hidden: !permittedCruds?.includes('DELETE'),

    //   label: (
    //     <ItemDeleteText onClick={() => onDelete()}>Delete User</ItemDeleteText>
    //   ),
    // },
  ]?.filter(item => !item.hidden)

  const menu = <ActionMenu width={'165px'} items={menuItems} />

  return (
    <Main id="view_dropdown">
      {menuItems?.length ? (
        <StyledDropDownButton
          overlay={menu}
          shape="round"
          trigger={['click']}
          icon={<DownArrow />}
          getPopupContainer={() => document.getElementById('view_dropdown')}
        >
          <ButtonText onClick={() => onClickView(rowData?._id)}>
            View
          </ButtonText>
        </StyledDropDownButton>
      ) : (
        <ViewButton
          onClick={() => onViewClick(jobId)}
          text={'View'}
          height="32px"
        />
      )}
    </Main>
  )
}

export default ActionDropdown
